import { ElementType } from "react";

const colorMap = {
  green: {
    bg: "from-green-50 to-white dark:from-green-900/20 dark:to-gray-800",
    border: "border-green-100 dark:border-green-800",
    icon: "bg-green-500",
    ring: "ring-green-100 dark:ring-green-900",
  },
  indigo: {
    bg: "from-indigo-50 to-white dark:from-indigo-900/20 dark:to-gray-800",
    border: "border-indigo-100 dark:border-indigo-800",
    icon: "bg-indigo-500",
    ring: "ring-indigo-100 dark:ring-indigo-900",
  },
  blue: {
    bg: "from-blue-50 to-white dark:from-blue-900/20 dark:to-gray-800",
    border: "border-blue-100 dark:border-blue-800",
    icon: "bg-blue-500",
    ring: "ring-blue-100 dark:ring-blue-900",
  },
  yellow: {
    bg: "from-yellow-50 to-white dark:from-yellow-900/20 dark:to-gray-800",
    border: "border-yellow-100 dark:border-yellow-800",
    icon: "bg-yellow-500",
    ring: "ring-yellow-100 dark:ring-yellow-900",
  },
  purple: {
    bg: "from-purple-50 to-white dark:from-purple-900/20 dark:to-gray-800",
    border: "border-purple-100 dark:border-purple-800",
    icon: "bg-purple-500",
    ring: "ring-purple-100 dark:ring-purple-900",
  },
};

interface StaffStatCardProps {
  label: string;
  value: number | string;
  loading: boolean;
  color: keyof typeof colorMap;
  icon: ElementType<{ className?: string; "aria-hidden"?: boolean | "true" | "false" }>;
  subtitle?: string;
}

export default function StaffStatCard({
  label,
  value,
  loading,
  color,
  icon: Icon,
  subtitle,
}: StaffStatCardProps) {
  const colors = colorMap[color];
  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-br ${colors.bg} px-4 py-5 border-2 ${colors.border} shadow-md sm:px-6 sm:py-6 rounded-xl hover:shadow-lg hover:-translate-y-1 transition`}
    >
      <dt>
        <div className={`absolute rounded-lg ${colors.icon} p-3 ring-4 ${colors.ring}`}>
          <Icon className="h-8 w-8 text-white" aria-hidden="true" />
        </div>
        <p className="ml-20 truncate text-sm font-semibold text-gray-700 dark:text-gray-300">
          {label}
        </p>
      </dt>
      <dd className="ml-20 flex flex-col items-baseline">
        <p className="text-3xl font-extrabold font-sans text-gray-900 dark:text-white">
          {loading ? (
            <span className="inline-block w-16 animate-pulse rounded bg-gray-200 dark:bg-gray-600">
              &nbsp;
            </span>
          ) : (
            value
          )}
        </p>
        {subtitle && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</p>
        )}
      </dd>
    </div>
  );
}
